import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import { Images } from "config/images";
import { formatCash } from "config/constant";
import PromotionItem from "./Components/PromotionItem";

const PromotionDetail = memo(props => {
	const classes = useStyles();
	const { campaign, promotion } = props;

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				<Grid
					classes={{ root: classes.title }}
					style={{
						width: `calc(100% - (${
							!!promotion?.groups ? 130 : 30
						})px)`
					}}
				>
					<img src={Images.icGift} alt={"icGift"} />
					<Grid
						classes={{ root: classes.threeDot }}
						style={{
							width: !!promotion?.groups ? 190 : 270
						}}
					>
						{campaign?.name}
					</Grid>
				</Grid>
				{!!promotion?.groups && (
					<Grid classes={{ root: classes.quantity }}>
						tặng <span>{promotion?.groups[0]?.quantity || 0}</span>{" "}
						(lẻ)
					</Grid>
				)}
			</Grid>
			{promotion?.type === "PROMOTION_ITEM_QUANTITY_GIFT" ||
			promotion?.type === "PROMOTION_ITEM_AMOUNT_GIFT" ? (
				promotion?.groups?.map((group, index) => (
					<PromotionItem key={index} group={group} />
				))
			) : (
				<Grid classes={{ root: classes.bodyTextDiscount }}>
					<Grid>Tặng {promotion?.discountPercent}% chiết khấu</Grid>
					<Grid>{formatCash(promotion?.amountDiscount)} đ</Grid>
				</Grid>
			)}
		</Grid>
	);
});

export default PromotionDetail;
